import { VideoProject } from "@/services/bedrock";

import { getKanbanColumnId, KANBAN_COLUMNS, KanbanColumnId } from "./kanbanColumns";

export const EDITOR_QUEUE_VIDEO_PROJECT_CHANGED = "video_project.changed";
export const EDITOR_QUEUE_ASSIGNMENTS_CHANGED = "queue_assignments.changed";

export type EditorQueueVideoProjectChanged = {
  type: typeof EDITOR_QUEUE_VIDEO_PROJECT_CHANGED;
  videoProjectId: number;
  fromStatus?: VideoProject.Status | string | null;
  toStatus?: VideoProject.Status | string | null;
  archived?: boolean;
  actorUserId?: number | null;
};

export type EditorQueueAssignmentsChanged = {
  type: typeof EDITOR_QUEUE_ASSIGNMENTS_CHANGED;
  coachId: number;
};

export type EditorQueueEvent = EditorQueueVideoProjectChanged | EditorQueueAssignmentsChanged;

export function isEditorQueueEvent(value: unknown): value is EditorQueueEvent {
  if (!value || typeof value !== "object") return false;

  const event = value as { type?: unknown; videoProjectId?: unknown; coachId?: unknown };
  if (event.type === EDITOR_QUEUE_ASSIGNMENTS_CHANGED) {
    return typeof event.coachId === "number";
  }
  if (event.type === EDITOR_QUEUE_VIDEO_PROJECT_CHANGED) {
    return typeof event.videoProjectId === "number";
  }
  return false;
}

export function columnIdsForEditorQueueEvent(event: EditorQueueEvent): KanbanColumnId[] {
  if (event.type === EDITOR_QUEUE_ASSIGNMENTS_CHANGED) {
    return allKanbanColumnIds();
  }

  const columnIds = [event.fromStatus, event.toStatus]
    .map(status => (status ? getKanbanColumnId(status as VideoProject.Status) : undefined))
    .filter((columnId): columnId is KanbanColumnId => columnId != null);

  return columnIds.length > 0 ? [...new Set(columnIds)] : allKanbanColumnIds();
}

function allKanbanColumnIds(): KanbanColumnId[] {
  return KANBAN_COLUMNS.map(column => column.id);
}
